import { Tabs } from 'react-vant'
import VoteList from '@/pages/Home/Vote/components/VoteList'
import { Helmet } from '@umijs/max'
import { useState } from 'react';

const Vote = () => {
  const [activeTab, setActiveTab] = useState('all');
  const itemList = [{
    key: 1,
    label: '全部',
    name: 'all'
  },{
    key: 2,
    label: '进行中',
    name: 'Ing'
  },{
    key: 3,
    label: '已提交',
    name: 'submited'
  }]

  const tabChange = (name: any) => {
    setActiveTab(name)
  };
  return (
    <div className='demo-tabs'>
      <Helmet>
        <title>投票</title>
      </Helmet>
      <Tabs active={activeTab} sticky={true} onChange={tabChange}>
        {itemList.map(item => (
          <Tabs.TabPane key={item.name} name={item.name} title={`${item.label}`}>
            {activeTab === item.name && <VoteList key={item.name}  type={item.key}></VoteList>}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  )
}

export default Vote